export const menuData = {
  renderDecorations: true,
};
